import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  importGeographyFailed, importGeographySuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* importGeography(action) {
  try {
    const headers = {
      Accept: 'multipart/form-data',
      'Content-Type': 'multipart/form-data',
    };
    const pool = action.payload;
    const url = `${BACKEND_URL}/geography/import`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true, headers, true);
    if (dataResponse.status === OK) {
      yield put(importGeographySuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(dataResponse);
      yield put(importGeographyFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(importGeographyFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
